import React from "react";

const CartItem = ({ data, cartDispatch }) => {
  const { id, title, brand, thumbnail, price,discountPercentage, qty, stock } = data;
  const discountedPrice = price - price * (discountPercentage / 100);
  const quantityHandler = (value) => {
    const obj = { id: id, qty: value };
    cartDispatch({ type: "UPDATE_QUANTITY", payload: obj });
  };

  const deleteHandler = () => {
    cartDispatch({ type: "REMOVE_FROM_CART", payload: { id } });
  };
  return (
    <div className="flex items-center p-2 shadow- ">
      <div className="flex w-2/5 items-center">
        <div className="w-32">
          <img className="object-contain" src={thumbnail} alt="" />
        </div>
        <div className="flex flex-col h-full ml-4">
          <span className="font-bold text-base">{title}</span>
          <span className="text-xs mt-2 text-red-300">{brand}</span>
        </div>
      </div>
      <div className="flex justify-center w-1/5">
        <div className="join">
          <button
            className="join-item btn btn-sm text-lg btn-neutral disabled:bg-neutral"
            onClick={() => quantityHandler(qty - 1)}
            disabled={qty === 1}
          >
            -
          </button>
          <button className="join-item btn btn-sm">{qty}</button>
          <button
            className="join-item btn btn-sm text-lg btn-neutral disabled:bg-neutral"
            onClick={() => quantityHandler(qty + 1)}
            disabled={qty === stock}
          >
            +
          </button>
        </div>
      </div>
      <div className="text-center w-1/5 flex flex-col items-center gap-1">
        <span className="text-xs">Price </span>
        <span className="font-semibold text-sm">${discountedPrice.toFixed(2)}</span>
      </div>
      <div className="text-center w-1/5 flex flex-col items-center gap-1">
        <span className="text-xs">Total Price </span>
        <span className="font-semibold text-sm">${(discountedPrice * qty).toFixed(2)}</span>
      </div>

      <button onClick={deleteHandler}>
        <svg
          x="0px"
          y="0px"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          className="text-warning"
          fill="#d11a2a"
        >
          <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z"></path>
        </svg>
      </button>
    </div>
  );
};

export default CartItem;
